import axios from "axios";
import store from "./store";
import { loaderActions } from "./store/loaderSlice";
import { logout } from "./store/authSlice";   // ← named import (was: default import of REDUCER)
import { warningActions } from "./store/warningSlice";

// CLAUDE-SYNC: v1.7 — request timeout added (2026-08-06). Previously unset, so a
// duty-toggle or location-ping request on poor facility connectivity would hang
// indefinitely with no error and no feedback to the user — leading to duplicate
// clock-in/out entries once connectivity returned and a second tap landed.
// See TopBar.jsx / SettingsPanel.jsx for the matching client-side guard.
axios.defaults.timeout = 15000;

axios.interceptors.request.use(function (request) {

  if (!request.hideLoader) {
    store.dispatch(loaderActions.fetching());
  }
  return request;
});

axios.interceptors.response.use(
  function (response) {

    if (!response.config.hideLoader) {
      store.dispatch(loaderActions.fetched());
    }

    return response;
  },
  function (error) {
    if (!error.config?.hideLoader) {
      store.dispatch(loaderActions.fetched());
    }

    // CLAUDE-SYNC: v1.7 — friendlier message when the request timed out rather
    // than genuinely failing, so field staff know to retry instead of assuming
    // the app is broken (2026-08-06)
    const isTimeout = error.code === 'ECONNABORTED';
    store.dispatch(warningActions.showWarning(
      isTimeout
        ? {
            title: 'Connection Lost',
            message: "We couldn't reach the server in time. Check your connection and try again.",
          }
        : {}
    ));

    if (error.response?.status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

export default axios;
